var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimeTimeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7616",
    "data-name": "Group 7616",
    transform: "translate(-3269 -8752)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21496",
    "data-name": "Rectangle 21496",
    width: 13,
    height: 13,
    transform: "translate(3269 8752)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7615",
    "data-name": "Group 7615",
    transform: "translate(2787.655 8338.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4876",
    "data-name": "Path 4876",
    d: "M494.154,418.366a.575.575,0,0,0-.464-.391l-3.682-.535-1.647-3.336a.575.575,0,0,0-1.031,0l-1.647,3.336-3.682.535a.575.575,0,0,0-.319.981l2.664,2.6-.629,3.667a.575.575,0,0,0,.834.606l3.293-1.731,3.293,1.731a.575.575,0,0,0,.834-.606l-.629-3.667,2.664-2.6A.575.575,0,0,0,494.154,418.366Z",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeTimeBlack);
export default __webpack_public_path__ + "static/media/prime-time-black.914f6f25c4d940c042a8dfb4cec1e45c.svg";
export { ForwardRef as ReactComponent };